module.exports = __webpack_public_path__ + "static/img/cabecera.4d8de50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente-en/cabecera.jpg
// module id = GB09
// module chunks = 0